module.exports = __webpack_public_path__ + "static/merlin-84e754cb2b86e73b64b40b4ff070f770.jpg";